import { useMessage } from '@tmapy/intl';

import { SuccessBadge, WarningBadge, InfoBadge } from '@tmapy/style-guide';

import { PUBLISHSET_STATES } from '../constants';
import { publishsetStateMessages } from './publishsetMessages';

type PublishsetStateBadgeProps = {
  state: PUBLISHSET_STATES;
};

export const PublishsetStateBadge: React.FC<PublishsetStateBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();
  const label = formatMessage.lookup(publishsetStateMessages, PUBLISHSET_STATES[state]);

  switch (state) {
    case PUBLISHSET_STATES.PREPARING: {
      return <WarningBadge isStrong>{label}</WarningBadge>;
    }
    case PUBLISHSET_STATES.PUBLISHED: {
      return <SuccessBadge isStrong>{label}</SuccessBadge>;
    }
    case PUBLISHSET_STATES.ARCHIVED: {
      return <InfoBadge>{label}</InfoBadge>;
    }
    default: {
      console.error('PublishsetStateBadge: Unknown state', state);
      return state;
    }
  }
};
